import store from 'store/storeConfig';
import { SurveyStatus } from 'constants/enums';

export const buildQuestionnaireOptions = (groupQuestionnaires: any[]) => {
  const { intl } = store.getState();
  return (
    groupQuestionnaires
      ?.filter((questionnaire) => parseInt(questionnaire.status) === SurveyStatus.PUBLISHED)
      ?.map((questionnaire) => ({
        label: intl.messages[questionnaire.title] || questionnaire.title,
        value: questionnaire.title
      }))
      ?.sort((a, b) => (a.label < b.label ? -1 : 1)) || []
  );
};

export const buildScoresOptions = (groupQuestionnaires: any[]) => {
  const { intl } = store.getState();
  return (
    groupQuestionnaires
      ?.filter(
        (questionnaire) =>
          questionnaire.score && parseInt(questionnaire.status) === SurveyStatus.PUBLISHED
      )
      ?.map((questionnaire) => {
        return {
          label: intl.messages[questionnaire.title] || questionnaire.title,
          value: questionnaire.score.title
        };
      })
      .sort((a, b) => (a.label < b.label ? -1 : 1)) || []
  );
};

export const getSurveyIdFromTitle = (questionnaires: ISurvey[], title: string) => {
  const survey = questionnaires.find((questionnaire) => questionnaire.title === title);
  return survey?.survey_id || survey?.surveyId;
};

export const getSurveyStatusOptions = () => {
  const { intl } = store.getState();
  return [
    {
      label: intl.messages['draftKey'],
      value: SurveyStatus.DRAFT.toString()
    },
    {
      label: intl.messages['publishedKey'],
      value: SurveyStatus.PUBLISHED.toString()
    }
  ];
};
